import { render, staticRenderFns } from "./ReversePutaway.vue?vue&type=template&id=6e874a0c&"
import script from "./ReversePutaway.vue?vue&type=script&lang=js&"
export * from "./ReversePutaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports